
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.995 13.094l-4.578-4.547C13.319 4.628 10.444 0 6.004 0 2.694 0 0 2.676 0 5.965c0 4.338 4.523 7.199 8.457 5.444l4.617 4.586c1.314.11 3.034-1.55 2.92-2.9zm-9.99-3.147c-2.211 0-4.01-1.787-4.01-3.982 0-2.196 1.799-3.982 4.01-3.982 2.21 0 4.009 1.786 4.009 3.982 0 2.195-1.8 3.982-4.01 3.982z","fill":"#3F51B5"}})])
          )
        }
      }
    